import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, createVNode as _createVNode, renderSlot as _renderSlot, createElementVNode as _createElementVNode, unref as _unref, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveDirective as _resolveDirective, withCtx as _withCtx, renderList as _renderList, createSlots as _createSlots, openBlock as _openBlock, createBlock as _createBlock, withDirectives as _withDirectives, normalizeClass as _normalizeClass, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = (n: any) => (_pushScopeId("data-v-26cb3b1a"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "d-flex pa-2" }

import { ref, watch, type Ref, computed, onMounted } from "vue";
import { APIObject, DatabaseObject, PaginatedResponse } from "@/classes";
import { useFilterStore } from "@/store/filter";
import { FilterDefinition } from "@/types/filter";
import { DataTableHeader, DataTableOptions } from "@/types/table";
import { setupApiQueue } from "../api-queue";
import { setupWindowSize } from "./window";


export default /*#__PURE__*/_defineComponent({
  __name: 'PaginatedTable',
  props: {
    table: {},
    tableClass: {},
    filterDefinitions: {},
    headers: {},
    itemsPerPageOptions: { default: () => [
      { value: 10, title: "10" },
      { value: 25, title: "25" },
      { value: 50, title: "50" },
      { value: 100, title: "100" },
    ] },
    heightOffset: { default: 180 }
  },
  setup(__props: any, { expose: __expose }) {

const props = __props;

const filterStore = useFilterStore();
filterStore.initialise(props.table, props.filterDefinitions);

watch(
  () => filterStore.values,
  async () => {
    await getData();
  },
  { deep: true },
);

const { loading, queueApiAction } = setupApiQueue();

const options = ref<DataTableOptions>({
  itemsPerPage: 10,
  page: 1,
  sortBy: [],
});
const data = ref<PaginatedResponse<DatabaseObject>>(
  new PaginatedResponse<DatabaseObject>(),
);

const updateOptions = async (dataTableOptions: DataTableOptions) => {
  options.value = dataTableOptions;
  await getData();
};

const getData = async () => {
  const sorts = options.value.sortBy.map((sort) => {
    const header = props.headers.find((h) => h.key === sort.key) as
      | DataTableHeader
      | undefined;
    return [header?.sortkey ?? sort.key, sort.order === "desc"] as [
      string,
      boolean,
    ];
  });
  await queueApiAction(async () => {
    data.value = await props.tableClass.paginated(
      filterStore.values,
      sorts,
      options.value.page - 1,
      options.value.itemsPerPage,
    );
  });
};

const { windowSize, onResize } = setupWindowSize();

__expose({ getData });

return (_ctx: any,_cache: any) => {
  const _component_v_spacer = _resolveComponent("v-spacer")!
  const _component_v_divider = _resolveComponent("v-divider")!
  const _component_v_data_table_server = _resolveComponent("v-data-table-server")!
  const _directive_resize = _resolveDirective("resize")!

  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass({
      'height-full': true,
      'mobile-table': _ctx.$device.isMobile,
      'desktop-table': !_ctx.$device.isMobile,
    }),
    style: {"overflow-y":"auto"}
  }, [
    _createElementVNode("div", _hoisted_1, [
      _createVNode(_component_v_spacer),
      _renderSlot(_ctx.$slots, "right-actions")
    ]),
    _createVNode(_component_v_divider),
    _withDirectives((_openBlock(), _createBlock(_component_v_data_table_server, {
      items: data.value.items,
      headers: _ctx.headers,
      loading: !!_unref(loading),
      "items-length": data.value.count,
      "items-per-page-options": _ctx.itemsPerPageOptions,
      height: _unref(windowSize).y - _ctx.heightOffset,
      "fixed-header": "",
      "onUpdate:options": updateOptions
    }, _createSlots({ _: 2 }, [
      _renderList(_ctx.headers, (header) => {
        return {
          name: `item.${header.key}`,
          fn: _withCtx(({ item }) => [
            _renderSlot(_ctx.$slots, `item.${header.key}`, { item: item }, () => [
              _createTextVNode(_toDisplayString(item[header.key]), 1)
            ])
          ])
        }
      })
    ]), 1032, ["items", "headers", "loading", "items-length", "items-per-page-options", "height"])), [
      [_directive_resize, _unref(onResize)]
    ]),
    _renderSlot(_ctx.$slots, "default")
  ], 2))
}
}

})